export const ATTACHMENTS_BUCKET =
  import.meta.env.VITE_ATTACHMENTS_BUCKET || "attachments";
